import { useState } from 'react';
import AiJobChips from './AiJobChips';
import SpecQueueButton from './SpecQueueButton';

interface AiTaskJobsProps {
  taskId: string;
  taskTitle: string;
  style?: React.CSSProperties;
  refreshKey?: number;
  onEnqueued?: () => void;
}

/** AI job chips + Spec Queue button for a fulfillment task. */
export default function AiTaskJobs({ taskId, taskTitle, style, refreshKey = 0, onEnqueued }: AiTaskJobsProps) {
  const [tick, setTick] = useState(0);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', ...style }}>
      <AiJobChips taskId={taskId} refreshKey={tick + refreshKey} />
      <SpecQueueButton
        taskId={taskId}
        taskTitle={taskTitle}
        onEnqueued={() => {
          setTick((n) => n + 1);
          onEnqueued?.();
        }}
      />
    </div>
  );
}
